"use client";

import { Fragment } from "react";
import { useHistoryManager } from "../history/useHistoryManager";
import {
  getAccessPoint,
  getAccessPointId,
  getAccessPoints,
  getOrganisation,
} from "../slice/accessOrg-slice";
import { useAppSelector } from "../slice/hooks";

const BreadcrumbMenu = ({
  categoryName,
  categoryPath,
  categoryUrlData,
  className,
  items,
  productName,
  sauce,
  setSearchTerm,
  storeLabel,
  storeName,
  storePath,
  storeUrlData,
}) => {
  const { navigateTo } = useHistoryManager();
  const organisation = useAppSelector(getOrganisation);
  const accessPointId = useAppSelector(getAccessPointId);
  const accessPoint = useAppSelector(getAccessPoint);
  const accessPoints = useAppSelector(getAccessPoints);

  const clearSearch = () => {
    setSearchTerm?.("");
  };

  const defaultUrlData = {
    organisation: organisation,
    accessPointId: accessPointId,
    accessPoint: accessPoint,
    accessPoints: accessPoints,
  };

  const goHome = () => {
    clearSearch();
    navigateTo("home", {
      urlData: defaultUrlData,
    });
  };

  const goMarketplace = () => {
    clearSearch();
    navigateTo(
      "market-place",
      {
        urlData: {
          accessPoint: null,
          accessPoints: [],
          accessPointId: null,
          organisation: null,
        },
      },
      false,
    );
  };

  const navigateBreadcrumbItem = (item) => {
    if (!item || item.disabled || item.active) return;

    clearSearch();

    if (typeof item.onClick === "function") {
      item.onClick(item);
      return;
    }

    if (!item.path) return;

    navigateTo(
      item.path,
      {
        ...(item.navigationOptions || {}),
        urlData: item.urlData || item.navigationOptions?.urlData || defaultUrlData,
      },
      item.addToHistory ?? false,
    );
  };

  const getLegacyItems = () => {
    if (sauce === "marketplace-store") {
      return [
        {
          label: "Market Place",
          onClick: goMarketplace,
        },
        {
          label: storeLabel || "Store",
          path: storePath,
          urlData: storeUrlData,
          active: !storePath,
        },
      ];
    }

    if (sauce === "product") {
      return [
        {
          label: storeName || storeLabel || "Store",
          path: storePath,
          urlData: storeUrlData,
        },
        categoryName
          ? {
              label: categoryName,
              path: categoryPath,
              urlData: categoryUrlData || storeUrlData,
              active: !categoryPath,
            }
          : null,
        {
          label: productName || "Product",
          active: true,
        },
      ];
    }

    return [
      {
        label: "Home",
        onClick: goHome,
        active: false,
      },
      sauce === "search"
        ? {
            label: "Search Results",
            active: true,
          }
        : null,
    ];
  };

  const breadcrumbItems = (Array.isArray(items) && items.length
    ? items
    : getLegacyItems()
  ).filter(Boolean);

  const wrapperClassName = ["breadcrumbWrapper", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;
        const isActive = item.active ?? isLast;
        const canNavigate =
          !isActive &&
          !item.disabled &&
          (item.path || typeof item.onClick === "function");

        return (
          <Fragment key={`${item.label}-${index}`}>
            {index > 0 && <span className="separator">›</span>}
            <span
              className={`breadcrumbItem ${isActive ? "active" : ""}`}
              onClick={canNavigate ? () => navigateBreadcrumbItem(item) : undefined}
            >
              {item.label}
            </span>
          </Fragment>
        );
      })}
    </div>
  );
};

export default BreadcrumbMenu;
